const translations = {
  "en": {
    "%{var0} currently exhibits %{var1} buy signals and %{var2} sell signals. The %{var7} has been in an %{var3} since %{var4}, with a total price change of %{var5} during this period. Overall, the technical indicators point to a %{var6} outlook for the mid-term.": "%{var0} currently exhibits %{var1} buy signals and %{var2} sell signals. The %{var7} has been in an %{var3} since %{var4}, with a total price change of %{var5} during this period. Overall, the technical indicators point to a %{var6} outlook for the mid-term.",
    "Ask": "Ask",
    "Bullish/Bearish Signals": "Bullish/Bearish Signals",
    "Buy Signals": "Buy Signals",
    "Change": "Change",
    "Change price": "Change price",
    "Details": "Details",
    "downtrend": "downtrend",
    "Neutral Signals": "Neutral Signals",
    "Sell Signals": "Sell Signals",
    "stock": "stock",
    "TA analysis conclusion change": "TA analysis conclusion change",
    "The latest rating for %{var0} as of %{var1} is %{var2}.": "The latest rating for %{var0} as of %{var1} is %{var2}.",
    "token": "token",
    "uptrend": "uptrend"
  },
  "zh-tw": {
    "%{var0} currently exhibits %{var1} buy signals and %{var2} sell signals. The %{var7} has been in an %{var3} since %{var4}, with a total price change of %{var5} during this period. Overall, the technical indicators point to a %{var6} outlook for the mid-term.": "%{var0} 目前呈現 %{var1} 個買入訊號與 %{var2} 個賣出訊號。該 %{var7} 自 %{var4} 以來便進入 %{var3}，期間價格總計變動 %{var5}。綜合來看，各項技術指標預示中期前景為 %{var6}。",
    "Ask": "提問",
    "Bullish/Bearish Signals": "看漲/看跌訊號",
    "Buy Signals": "買入訊號",
    "Change": "變更",
    "Change price": "變更價格",
    "Details": "細節",
    "downtrend": "下跌趨勢",
    "Neutral Signals": "中性訊號",
    "Sell Signals": "賣出訊號",
    "stock": "股票",
    "TA analysis conclusion change": "TA分析結論變更",
    "The latest rating for %{var0} as of %{var1} is %{var2}.": "截至 %{var1}，%{var0} 的最新評分為 %{var2}。",
    "token": "代幣",
    "uptrend": "上漲趨勢"
  }
};

export default translations;
